var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRespIllustrationHome1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 277,
    viewBox: "0 0 141 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 0L121 0V253.5C121 266.479 110.479 277 97.5 277V277C84.5213 277 74 266.479 74 253.5V0Z",
    fill: "#E29578"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233.793,
    y: 141.198,
    width: 46.9065,
    height: 233.793,
    rx: 23.4532,
    transform: "rotate(90 233.793 141.198)",
    fill: "#005B7F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 254.053,
    y: 173.685,
    width: 38.5752,
    height: 233.793,
    rx: 19.2876,
    transform: "rotate(90 254.053 173.685)",
    fill: "#FFDDD2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265.793,
    y: 129,
    width: 31.1282,
    height: 233.793,
    rx: 15.5641,
    transform: "rotate(90 265.793 129)",
    fill: "#679ACB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 282.644,
    y: 155.359,
    width: 30.6786,
    height: 233.793,
    rx: 15.3393,
    transform: "rotate(90 282.644 155.359)",
    fill: "#E8F8FE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespIllustrationHome1);
export default __webpack_public_path__ + "static/media/Resp_IllustrationHOME_1.9675bd9b07aa10d3369024d632469fa5.svg";
export { ForwardRef as ReactComponent };